import {Rib} from '../../../interfaces/rib';
import PlaceholderText from '../../../common/components/placeholder/PlaceholderText';
import {KTSVG} from '../../../../_metronic/helpers';
import {useIntl} from 'react-intl';

interface PaymentInfosSummaryProps {
    rib: Rib;
    isLoading: boolean;
}

const PaymentInfosSummary = ({rib, isLoading}: PaymentInfosSummaryProps): JSX.Element => {
    const intl = useIntl();

    const {owner, ownerAddress, bank} = rib;

    return (
        <>
            <div className="row align-items-center">
                <div className="col">
                    <div className="fs-1 fw-semibold text-gray-700">
                        <PlaceholderText
                            isFetching={isLoading}
                            placeholderProps={{widthClassName: 'col-12'}}
                        >
                            {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.DEBIT'})}
                        </PlaceholderText>
                    </div>
                </div>

                <div className="col">
                    <KTSVG
                        path="/media/icons/duotune/finance/fin009.svg"
                        className="svg-icon-4x svg-icon-primary float-end"
                    />
                </div>
            </div>
            <div className="separator my-10"></div>
            <div className="d-flex flex-column">
                <div className="d-flex fs-5 fw-bold">
                    {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.ACCOUNT_HOLDER'})}
                </div>
                <div className="fs-6 fw-semibold text-gray-600">
                    <PlaceholderText
                        isFetching={isLoading}
                        placeholderProps={{widthClassName: 'col-4'}}
                    >
                        {owner}
                        <br />
                    </PlaceholderText>
                    <PlaceholderText
                        isFetching={isLoading}
                        placeholderProps={{widthClassName: 'col-8'}}
                    >
                        {ownerAddress}
                        <br />
                    </PlaceholderText>
                </div>
            </div>
            <br />
            {bank && (
                <div className="d-flex flex-column">
                    <div className="d-flex fs-5 fw-bold">
                        {intl.formatMessage({id: 'ADMINISTRATIVE.PAYMENT_MODE.RIB.BANK'})}
                    </div>
                    <div className="fs-6 fw-semibold text-gray-600">
                        <PlaceholderText
                            isFetching={isLoading}
                            placeholderProps={{widthClassName: 'col-4'}}
                        >
                            {bank}
                            <br />
                        </PlaceholderText>
                    </div>
                </div>
            )}
            <br />
        </>
    );
};

export default PaymentInfosSummary;
